import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { formatNumberToText } from "../../formatters/formatNumberToText";
export const FormatNumberToText = (props)=>{
    const formattedValue = formatNumberToText(props.value);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: formattedValue
    });
};
FormatNumberToText.displayName = 'FormatNumberToText';

//# sourceMappingURL=FormatNumberToText.js.map